import { useDateUtils } from 'composables/useDateUtils';

export const formatDateLabel = (date: string): string => {
    const { formatDateDisplayed } = useDateUtils();
    const target = moment(date, formatDateDisplayed.value);
    const now = moment();

    if (target.isSame(now, 'day')) {
        return window.i18n.__('common.labels.today');
    }

    if (target.isBefore(now, 'day')) {
        return target.format(formatDateDisplayed.value);
    }

    return target.fromNow();
};
